import { makeStyles } from '@material-ui/core';

import { Tag, TagGroup } from '@backstage/ui';

const useStyles = makeStyles({
  container: {
    alignItems: 'center',
    padding: 'var(--bui-space-2) 0',
    display: 'flex',
    flexWrap: 'wrap',
    gap: 'var(--bui-space-2)',
  },
  tagLabel: {
    maxWidth: '90px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    display: 'block',
  },
  newValue: {
    color: 'var(--bui-fg-success)',
  },
  oldValue: {
    color: 'var(--bui-fg-secondary)',
    textDecoration: 'line-through',
  },
});

export interface ActivityTagItemProps {
  tagLabel?: string;
  oldValue?: string;
  newValue?: string;
  defaultValue?: string;
  ariaLabel?: string;
}

export const ActivityTagItem = ({
  tagLabel,
  oldValue,
  newValue,
  defaultValue,
  ariaLabel = 'Change values',
}: ActivityTagItemProps) => {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      {tagLabel && (
        <TagGroup aria-label={ariaLabel}>
          <Tag size="small">{tagLabel}</Tag>
        </TagGroup>
      )}
      {oldValue && <span className={classes.oldValue}>{oldValue}</span>}
      {newValue && <span className={classes.newValue}>{newValue}</span>}
      {defaultValue && <span>{defaultValue}</span>}
    </div>
  );
};
